import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import SignaturePad from 'react-signature-canvas';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export const SignatureCanvas = forwardRef(({ onSave }, ref) => {
  const sigPadRef = useRef(null);

  useImperativeHandle(ref, () => ({
    clear: () => {
      if (sigPadRef.current) {
        sigPadRef.current.clear();
      }
    },
    isEmpty: () => {
      return sigPadRef.current ? sigPadRef.current.isEmpty() : true;
    },
    toDataURL: () => {
      return sigPadRef.current ? sigPadRef.current.toDataURL() : '';
    }
  }));

  const handleClear = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
    }
  };

  return (
    <div className="space-y-3">
      <div className="border-2 border-gray-300 rounded-md bg-white" style={{ width: '100%', height: '180px' }}>
        <SignaturePad
          ref={sigPadRef}
          canvasProps={{
            className: 'w-full h-full',
            style: { width: '100%', height: '180px' }
          }}
          backgroundColor="white"
        />
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={handleClear}
          data-testid="signature-clear-button"
          className="flex items-center gap-2"
        >
          <X className="h-4 w-4" />
          Limpiar
        </Button>
      </div>
    </div>
  );
});

SignatureCanvas.displayName = 'SignatureCanvas';
